import { slugify } from "./utils";

export const documentationContent = [
  {
    role: ["L"],
    section: "Lender's Help Guide",
    headings: [
      {
        heading: "Login & Password Recovery",
        id: "Lender's-Login",
        subHeadings: [
          {
            subHeading: "1.1 Login - Existing User",
            id: "Lender's-1.1",
            qa: [
              {
                question: "How do I log in as an existing user?",
                answer: [
                  "Click on the link provided by SLS to access the portal.",
                  "You will be redirected to the LoanLinQ portal login page.",
                  "Enter your registered username and password.",
                  "Click 'Continue' to generate an OTP sent to your registered email.",
                  "Enter the OTP and click 'Verify OTP and continue' to log in.",
                ],
                image: ["./assets/Login.png"],
              },
            ],
          },
          {
            subHeading: "1.2 Recover Password",
            id: "Lender's-1.2",
            qa: [
              {
                question: "What should I do if I forgot my password?",
                answer: [
                  "Click on 'Forgot Password?' on the login page.",
                  "A pop-up window will appear for resetting your password.",
                  "Enter your registered email address and click 'Next.'",
                  "You will receive an autogenerated key on your email.",
                  "Enter the key and click 'Next' to proceed with resetting your password.",
                ],
                image: ["./assets/recover_password.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Navigation",
        id: "Lender's-Navigation",
        subHeadings: [
          {
            subHeading: "2. Navigation",
            id: "Lender's-2.",
            qa: [
              {
                question: "What sections does the Navigation menu comprise?",
                answer: [
                  "This navigation menu comprises eight sections: Dashboard, Reports and Documents, Secure Document Upload, Forms, Help, Account, and a Guided tour. You can switch between these sections by simply clicking on them.",
                ],
                image: ["./assets/Navigation.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Dashboard",
        id: "Lender's-Dashboard",
        subHeadings: [
          {
            subHeading: "3. Dashboard",
            id: "Lender's-3.",
            qa: [
              {
                question: "What information does the Dashboard display?",
                answer: [
                  "Portfolio balance overview.",
                  "Upcoming payments summary.",
                  "Total number of loans and outstanding charges.",
                  "Loan aging and insurance expiry details.",
                  "Revenue breakdown and analysis.",
                  "Loan distribution by priority, maturity, and property type.",
                  "Portfolio-at-a-glance for quick insights.",
                  "Detailed views of past payments and loan portfolios.",
                ],
              },
            ],
          },
          {
            subHeading: "3.1 Dashboard - Lender Portfolio Balance",
            id: "Lender's-3.1",
            qa: [
              {
                question: "What is the Lender Portfolio Balance?",
                answer: [
                  "Lender Portfolio- The term 'Lender portfolio balance' typically refers to the total amount of funds that a lender has invested or allocated across various loans or investments within their portfolio. In a lender portal, it's a dashboard or summary section that displays this aggregated balance. This balance can fluctuate based on factors such as repayments, interest accruals, and new investments or loans made by the lender.",
                ],
                image: ["./assets/lender_portfolio_balance.png"],
              },
            ],
          },
          {
            subHeading: "3.2 Dashboard - Upcoming Payments",
            qa: [
              {
                question: "What are upcoming payments?",
                answer: [
                  "Upcoming payments on a lender portal typically refer to a section or feature that displays the scheduled payments that lenders are set to receive from borrowers within a certain timeframe. This feature is useful for lenders to monitor their incoming cash flows and to anticipate when they can expect to receive payments from borrowers. It helps lenders stay organized and manage their finances effectively.",
                ],
                image: ["./assets/upcoming_payments.png"],
              },
            ],
          },
          {
            subHeading:
              "3.3 Dashboard - Total Number of Loans and Outstanding Charges",
            qa: [
              {
                question:
                  "What information is displayed in the Total Number of Loans and Outstanding Charges?",
                answer: [
                  "In a lender portal, the 'total number of loans' metric is displayed prominently on a dashboard, providing lenders with a quick overview of the size and scope of their loan portfolio. Having access to this information allows lenders to track portfolio growth over time and monitor changes in the loan portfolio composition. The 'outstanding charges' section of the lender portal would display details such as the type of charge, the amount owed, loan account, and the status of the charge.",
                ],
                image: ["./assets/outstanding.png"],
              },
            ],
          },
          {
            subHeading: "3.4 Dashboard - Loan Aging and Insurance Expiry",
            qa: [
              {
                question: "What is Loan Aging and Insurance Expiry?",
                answer: [
                  "Loan aging provides lenders with insights into the payment behavior of borrowers and allows them to identify loans that may require closer attention or follow-up actions.",
                  "The 'Insurance expiry' section shows details of insurance policies linked to loans in the lender's portfolio expiring within the next 30 days. This helps lenders track upcoming expirations, allowing them to promptly renew coverage or address uninsured loan risks.",
                ],
                image: ["./assets/loan_aging.png"],
              },
            ],
          },
          {
            subHeading: "3.5 Revenue Breakdown and Analysis",
            qa: [
              {
                question:
                  "What does the Revenue Breakdown and Analysis section show?",
                answer: [
                  "Revenue refers to the total income generated from lending activities within a specified period, with detailed breakdowns of revenue sources, such as interest income versus fee income.",
                ],
                image: ["./assets/revenue_breakdown.png"],
              },
            ],
          },
          {
            subHeading: "3.6 Loan Distribution by Lien Priority",
            qa: [
              {
                question: "What is Loan Distribution by Lien Priority?",
                answer: [
                  "This refers to a breakdown or visualization of the loans within a lender's portfolio based on their lien priority, determining the order in which creditors are entitled to claim repayment in the event of default or foreclosure.",
                ],
                image: ["./assets/loan_distribution(3.6).png"],
              },
            ],
          },
          {
            subHeading: "3.7 Loan Aging",
            qa: [
              {
                question: "What is Loan Aging?",
                answer: [
                  "Loan Aging refers to the process of categorizing loans based on their age or the length of time they have been outstanding. This categorization helps lenders assess the risk associated with their loan portfolio and track the performance of loans over time.",
                  "In a lender portal, the 'loan aging' feature would display loans grouped into different age categories, such as current, 30 days past due, 60 days past due, etc. It provides lenders with insights into the payment behavior of borrowers and allows them to identify loans that may require closer attention or follow-up actions.",
                ],
                image: ["./assets/image(3.7).png"],
              },
            ],
          },
          {
            subHeading: "3.8 Loan Distribution by Maturity",
            qa: [
              {
                question: "What is Loan Distribution by Maturity?",
                answer: [
                  "This refers to a breakdown or visualization of the loans within a lender's portfolio based on their maturity dates.",
                ],
                image: ["./assets/loan_distribution(3.8).png"],
              },
            ],
          },
          {
            subHeading: "3.9 Loan Distribution by Property Type",
            qa: [
              {
                question: "What is Loan Distribution by Property Type?",
                answer: [
                  "This feature categorizes loans based on the type of property serving as collateral, helping lenders assess their exposure to different types of real estate assets.",
                ],
                image: ["./assets/loan_distribution(3.9).png"],
              },
            ],
          },
          {
            subHeading: "3.10 Portfolio at a Glance",
            qa: [
              {
                question: "What is the Portfolio at a Glance section?",
                answer: [
                  "Provides a concise overview of the lender's entire portfolio of loans, displaying key information such as the total number of loans, loan account numbers, next due dates, maturity dates, and the lender's principal investment in each loan.",
                ],
                image: ["./assets/image(3.10).png"],
              },
            ],
          },
          {
            subHeading: "3.11 Upcoming Payments",
            qa: [
              {
                question: "What are upcoming payments?",
                answer: [
                  "Upcoming payments on a lender portal typically refer to a section or feature that displays information about scheduled payments that borrowers are obligated to make in the near future. For lenders, the 'Upcoming payments' feature is useful for tracking expected cash inflows, managing cash flow projections, and ensuring timely receipt of payments from borrowers. It allows lenders to stay informed about upcoming payment obligations and take any necessary actions to follow up on payments or address any issues that may arise.",
                ],
                image: ["./assets/image(3.11).png"],
              },
            ],
          },
          {
            subHeading: "3.12 Loan Charges",
            qa: [
              {
                question: "What are Loan Charges?",
                answer: [
                  "Tracking pending loan charges for various borrower services is essential for effective financial management, risk mitigation, and customer communication.",
                ],
                image: ["./assets/image(3.12).png"],
              },
            ],
          },
          {
            subHeading: "3.13 Past Payments to Lender",
            qa: [
              {
                question: "What are Past Payments to Lender?",
                answer: [
                  "Displays a history of payments made by borrowers or servicing entities to the lender in previous periods, providing a detailed record of all payments received.",
                ],
                image: ["./assets/image(3.13).png"],
              },
            ],
          },
          {
            subHeading: "3.14 Past Loan Portfolio",
            qa: [
              {
                question: "What is the Past Loan Portfolio?",
                answer: [
                  "Provides a historical overview of loans that have been part of the lender's portfolio but are no longer active or current.",
                ],
                image: ["./assets/image(3.14).png"],
              },
            ],
          },
          {
            subHeading: "3.15 Attachment & Loan Boarding",
            qa: [
              {
                question: "What is Attachment & Loan Boarding?",
                answer: [
                  "Refers to a feature where lenders can download, manage, and view documents related to their loan portfolio.",
                ],
                image: ["./assets/image(3.15).png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Default Management",
        subHeadings: [
          {
            subHeading: "4. Default Management",
            qa: [
              {
                question: "What does Default Management include?",
                answer: [
                  "Overview of loans more than 30 days delinquent.",
                  "Loans currently under foreclosure.",
                  "Details of loans that have undergone workout plans post-default.",
                ],
                image: ["./assets/default_management.png"],
              },
            ],
          },
        ],
      },
      // {
      //   heading: "Secure Document Upload",
      //   subHeadings: [
      //     {
      //       subHeading: "5. Secure Document Upload",
      //       qa: [
      //         {
      //           question: "How do I upload documents securely?",
      //           answer: [
      //             "Use the Secure Document Upload section to upload necessary documents or request information from specific departments by providing relevant details such as loan account numbers and property addresses.",
      //           ],
      //           image: ["./assets/secure_document_upload.png"],
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   heading: "Forms",
      //   subHeadings: [
      //     {
      //       subHeading: "6. Forms",
      //       qa: [
      //         {
      //           question: "Where can I find and download forms?",
      //           answer: [
      //             "Visit the Forms section to download forms for loan servicing needs, including address changes, ACH enrollments, demand requests, and more.",
      //           ],
      //           image: ["./assets/forms.png"],
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        heading: "Help",
        subHeadings: [
          {
            subHeading: "5. Help",
            qa: [
              {
                question: "Where can I get help if I encounter issues?",
                answer: [
                  "The Help section provides contact information, FAQs, terms of service, and policy documents to assist with any queries or troubleshooting needs.",
                ],
                image: ["./assets/help.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Account",
        subHeadings: [
          {
            subHeading: "6. Account",
            qa: [
              {
                question: "How can I manage multiple accounts or roles?",
                answer: [
                  "Access different accounts or roles through the Account section to view portfolios from various perspectives, including broker views and brokerage-originated loans.",
                ],
                image: ["./assets/account.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Guided Tour",
        subHeadings: [
          {
            subHeading: "7. Guided Tour",
            qa: [
              {
                question: "What is the purpose of this guided tour?",
                answer: [
                  "The purpose of this guided tour is to provide a step-by-step walkthrough of the portal's features, functionalities, and navigation options. It aims to highlight key aspects of the portal to help users become comfortable and confident in utilizing the portal to accomplish their objectives efficiently.",
                ],
                image: ["./assets/guided_tour.png"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["B"],
    section: "Borrower's Help Guide",
    headings: [
      {
        heading: "Login & Password Recovery",
        subHeadings: [
          // {
          //   subHeading: "1.1 New User Registration",
          //   qa: [
          //     {
          //       question: "How do I register as a new user?",
          //       answer: [
          //         "SLS will email you an invitation code and a link to access the LoanLinQ portal.",
          //         "Click on the link to open the portal in your browser.",
          //         "Enter the invitation code, email address, mobile number, and create a password.",
          //         "Ensure your password includes lowercase and uppercase letters, numbers, and symbols.",
          //         "Click 'Register' to create your account.",
          //       ],
          //       image: ["./assets/registration.png"],
          //     },
          //   ],
          // },
          {
            subHeading: "1.1 Login - Existing User",
            qa: [
              {
                question: "How do I log in as an existing user?",
                answer: [
                  " Click on the link provided by SLS to access the portal.",
                  " You will be redirected to the LoanLinQ portal login page.",
                  " Enter your registered username and password.",
                  " Click 'Continue' to generate an OTP sent to your registered email.",
                  " Enter the OTP and click 'Verify OTP and continue' to log in.",
                ],
                image: ["./assets/borrower_login3.jpg"],
              },
            ],
          },
          {
            subHeading: "1.2 Recover Password",
            qa: [
              {
                question: "What should I do if I forgot my password?",
                answer: [
                  "Click on 'Forgot Password?' on the login page.",
                  "A pop-up window will appear for resetting your password.",
                  "Enter your registered email address and click 'Next.'",
                  "You will receive an autogenerated key on your email.",
                  "Enter the key and click 'Next' to proceed with resetting your password.",
                ],
                image: ["./assets/borrower_recover_password.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "BORROWER NAVIGATION",
        subHeadings: [
          // {
          // subHeading: "Navigation",
          // content: [
          //   "1. Loan Details",
          //   "2. Reports & Documents",
          //   "3. Secure Document Upload",
          //   "4. Help",
          //   "5. Account",
          //   "6. Guided Tour",
          // ],
          // },
          {
            subHeading: "Navigation",
            qa: [
              {
                question: "What sections does the Navigation menu comprise?",
                answer: [
                  "This navigation menu comprises six sections: Dashboard, Loan details, Account and Help resources, Contact Us, and Guided Tour.",
                  "You can switch between these sections by simply clicking on them.",
                  ,
                ],
                image: ["./assets/borrower_navigation2.png"],
              },
            ],
          },

          // {
          //   subHeading: "2.2 Reports & Documents",
          //   qa: [
          //     {
          //       question:
          //         "How do I access reports and documents related to my loan?",
          //       answer: [
          //         "Navigate to the Reports & Documents section to view and download reports such as Favorite reports, Scheduled reports and Delivered Reports.",
          //       ],
          //       image: ["./assets/borrower_reports.png"],
          //     },
          //   ],
          // },
          // {
          //   subHeading: "2.3 Support",
          //   qa: [
          //     {
          //       question: "What is the purpose of the Support section?",
          //       answer: [
          //         "The purpose of the Support section is for the borrower to create a ticket if they have any issue or problem to report. This ticket will be assigned directly to the Customer Service Representative (CSR) to resolve it.",
          //       ],
          //       image: ["./assets/borrower_support.png"],
          //     },
          //   ],
          // },
          // {
          //   subHeading: "2.4 Help",
          //   qa: [
          //     {
          //       question: "Where can I find help if I encounter issues?",
          //       answer: [
          //         "The Help section provides the contact information, to assist with any queries or troubleshooting needs.",
          //       ],
          //       image: ["./assets/borrower_help.png"],
          //     },
          //   ],
          // },
          // {
          //   subHeading: "2.5 Account",
          //   qa: [
          //     {
          //       question: "How can I manage my account information?",
          //       answer: [
          //         "Visit the Account section to update your account details or manage roles if applicable.",
          //       ],
          //       image: ["./assets/borrower_account.png"],
          //     },
          //   ],
          // },
          // {
          //   subHeading: "2.6 Guided Tour",
          //   qa: [
          //     {
          //       question: "What is the purpose of this guided tour?",
          //       answer: [
          //         "The purpose of this guided tour is to provide a step-by-step walkthrough of the portal's features, functionalities, and navigation options. It aims to highlight key aspects of the portal to help users become comfortable and confident in utilizing the portal to accomplish their objectives efficiently.",
          //       ],
          //       image: ["./assets/borrower_guided_tour.png"],
          //     },
          //   ],
          // },
        ],
      },
      {
        heading: "Dashboard",
        subHeadings: [
          {
            subHeading: "3. Dashboard",
            qa: [
              {
                question:
                  "What information can I find in the dashboard section?",
                answer: [
                  "The Loan Management Dashboard provides a snapshot of loan activity, showing totals for active, paid-off, and foreclosure loans.",
                  "A visual chart displays individual loan metrics.",
                  "Users can manage payments, view statements, and access calculators easily.",
                  "Navigation and user details are also included for quick access.",
                ],
                image: ["./assets/borrower_dashboard.png"],
              },
            ],
          },
          {
            subHeading: "3.1. Accounts Summary",
            qa: [
              {
                question:
                  "What information can I find in the dashboard section?",
                answer: [
                  "The Loan Management Dashboard provides a snapshot of loan activity, showing totals for active, paid-off, and foreclosure loans.",
                  "A visual chart displays individual loan metrics.",
                  "Users can manage payments, view statements, and access calculators easily.",
                  "Navigation and user details are also included for quick access.",
                ],
                image: ["./assets/borrower_dashboard.png"],
              },
            ],
          },
          {
            subHeading: "3.1. Accounts Summary",
            outerli: [
              "Provides an overview of the status of all loans being managed:",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "Total Active Loans: Represents the number of loans that are currently active and under management.",
                  "Total Loan Count: Shows the cumulative total number of loans, including active, paid-off, and those in foreclosure.",
                  "Paid off Loans: Indicates how many loans have been completely repaid by borrowers.",
                  "Loans in Foreclosure: Displays the number of loans that have entered foreclosure status due to borrower delinquency.",
                ],
              },
            ],
            image: ["./assets/borrower_account_summary.png"],
          },

          {
            subHeading: "3.2. Payment Summary",
            outerli: [
              "Displays key financial figures related to loan servicing:",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "Total UPB (Unpaid Principal Balance): The total remaining principal amount across all loans.",
                  "Total Interest Paid YTD (Year-To-Date): The sum of interest payments received so far in the current calendar year.",
                  "YTD Late Fees: The total amount of late payment fees charged to borrowers this year.",
                  "YTD NSF Fees (Non-Sufficient Funds): Fees resulting from failed transactions due to insufficient borrower funds. A negative value may indicate refunds or corrections.",
                ],
              },
            ],
            // image: ["./assets/borrower_account_summary.png"],
          },

          {
            subHeading: "3.3. Visual Representation",
            content: [
              "A bar graph or chart displaying loan-related data visually. Each bar corresponds to a loan and its value may represent a specific metric such as outstanding balance, interest paid, or total payments.",
            ],

            image: ["./assets/visual_representation.png"],
          },

          {
            subHeading: "3.4. Payments Section",

            qa: [
              {
                question: "",
                answer: [
                  "Same Day Payment: Allows users to make a payment that will be processed on the same day.",
                  "One Time Payment: Enables scheduling or submitting a single payment.",
                  "Payment History: Provides a detailed record of all past payments made by the borrower.",
                  "Manage Banking: Lets users add, update, or delete bank account information.",
                  "Request Payoff: Generates a payoff quote showing the total amount required to close the loan.",
                  "Recurring ACH: Set up or modify automated, recurring payments through the ACH network.",
                  ,
                ],
                image: [
                  { 0: "./assets/same_day_payment.jpg" },
                  { 1: "./assets/one_time.png" },
                  { 2: "./assets/payment_history_borrower.png" },
                  { 3: "./assets/manage_banking.png" },
                  { 4: "./assets/request_payoff.png" },
                  { 5: "./assets/recurring_ach.png" },
                ],
              },
            ],
          },
          {
            subHeading: "3.5. Quick Access",
            content: [
              "View Statement: Access monthly or quarterly loan statements.",
              "Reports: Generate various reports on loans, payments, and account statuses. This is the main dashboard under the Reports and Documents section. It provides a snapshot of financial data related to the selected borrower account.",
              "Interest Calculator: A utility to compute interest amounts over time based on loan parameters.",
              "Payoff Calculator: A tool to calculate the total amount needed to fully pay off a loan based on the selected date.",
            ],
            image: [
              { 0: "./assets/quick_access.png" },
              { 1: "./assets/reports_borrower.png" },
              { 2: "./assets/interest_calc.png" },
              { 3: "./assets/payoff_calc.png" },
            ],
            multipleCase: true,
          },
          {
            subHeading: "1.2 Dashboard",
            content: [
              "This dashboard provides key loan and borrower details. The visual chart displays financial data for various loans. The ACH status shows how many loans are on recurring payments and those not enrolled. Loans maturing soon and insurance expiring within 30 days are highlighted for timely action. The loan aging section uses a donut chart to show overdue loan distributions. Lastly, ticket status reflects the number of closed and pending support requests.",
            ],
            image: ["./assets/borrower_dashboard(1.2).png"],
          },
          {
            subHeading: "3.6. Create Ticket",
            outerli: [
              "You can also create tickets when we click on create tickets",
              "When we click view all then it will show closed tickets and open tickets tickets.",
            ],
            image: ["./assets/borrower_ticket1.png"],
          },

          {
            subHeading: "3.7 ACH Status",
            content: [
              "This section displays the Monthly Recurring Payment Schedule for loans.",
              "It shows scheduled and non-scheduled loans for ACH (automated) payments.",
              "Each row includes the loan account, property address, ACH debit amount, the due day for debit, and the next scheduled debit date.",
              "Borrowers can select loans to update or set up ACH for automatic payments. This helps ensure timely payments and avoid late fees.",
            ],
            image: ["./assets/borrower_recurring.png"],
          },

          {
            subHeading: "3.8 Loans Maturing",
            content: [
              "The Loans Maturing section shows the number of loans that are approaching their maturity date.",
              "It alerts the borrower or admin to take necessary actions such as refinancing, payoff, or extension before the loan term ends.",
              "This helps in proactive loan management and prevents missed deadlines.",
            ],
            // image: ["./assets/borrower_recurring.png"],
          },

          {
            subHeading: "3.9 Insurance Expiring",
            content: [
              "The Insurance Expiring section displays the number of loans with insurance policies that are set to expire within the next 30 days.",
              "This alert helps ensure timely renewal of insurance to maintain compliance with loan terms and protect the property.",
            ],
            // image: ["./assets/borrower_recurring.png"],
          },

          {
            subHeading: "3.10 What is the Active Demand Payoff Loans?",
            content: [
              "The Active Demand Payoff Loans section displays loans for which a demand payoff has been issued and is currently active.",
              `This typically means the lender has requested full repayment of the remaining loan
balance. These loans are closely monitored due to their urgency and legal significance.`,
              `It helps administrators track and manage loans requiring immediate attention for
resolution or collection.`,
            ],
            image: ["./assets/active_payoff.png"],
          },
        ],
      },
      {
        heading: "Loan Details",
        subHeadings: [
          {
            subHeading: "4. Loan Details",
            qa: [
              {
                question: "What is Loan details?",
                answer: [
                  "In the Loan Details page, the two main sections — Loan Summary and Loan Details — serve different purposes:",
                  `Loan Summary provides a quick overview of the loan's key financial data. This typically
includes the unpaid principal balance, interest rate, maturity date, payment status, and next
due date, giving users a high-level snapshot of the loan’s current standing.`,
                  `Loan Details dives deeper into the loan’s structure and terms. It includes information such as
the original loan amount, loan type, property address, escrow details, borrower information,
and more specific contractual terms.`,
                ],
                image: ["./assets/borrower_loan_detail1.png"],
              },
            ],
          },
          {
            subHeading: "4.1 Loan Summary",
            content: [
              `This section displays an overview of the loan, including the loan type, status (e.g., Paid Off),
total loan amount, disbursed funds, outstanding balance, and payment frequency. It also
shows key dates like the loan’s closing date and maturity date to help track the loan lifecycle.`,
            ],
            // image: ["./assets/borrower_recurring.png"],
          },
          {
            subHeading: "4.1.1 Quick Actions",
            content: [
              `Quick-access buttons allow users to take key actions like making payments, setting up
autopay, viewing the trust ledger, and accessing attachments. This section simplifies
managing the loan efficiently.`,
            ],
            qa: [
              {
                question: "What are Pay Dues?",
                answer: [
                  `This option allows the borrower to make any outstanding loan payments directly.
It covers scheduled payments like principal and interest or any other amounts
due.`,
                ],
                image: ["./assets/pay_dues1.png"],
              },

              {
                question: "What is Set Autopay?",
                answer: [
                  `This feature lets the borrower set up automatic monthly payments through ACH (Automated
Clearing House). It ensures that loan payments are made on time without manual
intervention.`,
                ],
                image: ["./assets/autopay.png"],
              },
            ],
            // image: ["./assets/borrower_recurring.png"],
          },
          {
            subHeading: "4.2 Loan Details",
            content: [
              `This part gives more detailed financial and contact information. It includes insurance details account
holder info with contact details, and the current status of payments. It also shows available actions
like paying dues, setting up autopay, and viewing documents like the trust ledger or attachments.`,
            ],
            image: ["./assets/borrower_loan_details3.png"],
          },

          {
            subHeading: "4.2.1 Property Info",
            content: [
              `This section provides details about the property tied to the loan, such as the address,
property type, and possibly its valuation or usage (e.g., residential, commercial). It
helps identify the collateral for the loan.`,
            ],
            image: ["./assets/property_info.png"],
          },

          {
            subHeading: "4.2.2 Attachments:",
            content: [
              `Attachments include documents uploaded to the loan file, such as loan agreements,
insurance certificates, property appraisals, or borrower communication. It serves as a
document repository.`,
            ],
            image: ["./assets/borrower_attachments1.png"],
          },

          {
            subHeading: "4.2.3 Reserves:",
            content: [
              `Reserves are funds set aside from the borrower to cover future obligations, such as
taxes or insurance. This section tracks how much is collected and held for these
specific purposes.`,
            ],
            image: ["./assets/borrower_reserves.png"],
          },

          {
            subHeading: "4.2.4 Impounds:",
            content: [
              `Impounds are similar to reserves but are specifically held to pay recurring property-
related expenses like property taxes and insurance premiums on the borrower’s
behalf. These are managed by the lender or servicer.`,
            ],
            image: ["./assets/borrower_impounds.png"],
          },

          {
            subHeading: "4.2.5 Loan Terms:",
            content: [
              `This section outlines the structure of the loan—such as interest rate, duration,
payment schedule, maturity date, and any prepayment clauses. It defines the basic
agreement terms.`,
            ],
            image: ["./assets/loan_terms.png"],
          },

          {
            subHeading: "4.2.6 Loan Charges:",
            content: [
              `Loan charges list any fees associated with the loan—like origination fees, late
payment charges, servicing fees, or other administrative costs. It gives a breakdown of all
costs applied to the loan.`,
            ],
            image: ["./assets/loan_charges.png"],
          },

          {
            subHeading: "4.2.7 What are payment activity",
            content: [
              `Payment activity displays all past transactions including important details`,
              `Such as the transaction date, due date, payment code, and how the payment is allocated
between principal and interest, along with the total amount paid.`,
            ],
            image: ["./assets/payment_activity2.png"],
          },
        ],
      },
      {
        heading: "Account",
        subHeadings: [
          {
            subHeading: "5. Account",
            qa: [
              {
                question: "How can I manage multiple accounts or roles?",
                answer: [
                  "Access different accounts or roles through the Account section to view portfolios from various perspectives, including broker views and brokerage-originated loans.",
                ],
                image: ["./assets/account.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Help",
        subHeadings: [
          {
            subHeading: "6. Help",
            qa: [
              {
                question: "Where can I get help if I encounter issues?",
                answer: [
                  "The Help section provides contact information, FAQs, terms of service, and policy documents to assist with any queries or troubleshooting needs.",
                ],
                image: ["./assets/help.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Guided Tour",
        subHeadings: [
          {
            subHeading: "9. Guided Tour",
            qa: [
              {
                question: "What is the purpose of this guided tour?",
                answer: [
                  "The purpose of this guided tour is to provide a step-by-step walkthrough of the portal's features, functionalities, and navigation options. It aims to highlight key aspects of the portal to help users become comfortable and confident in utilizing the portal to accomplish their objectives efficiently.",
                ],
                image: ["./assets/guided_tour.png"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    role: [],
    section: "Lead's Ticketing System",
    headings: [
      {
        heading: "1. Lead Submission",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Leads fill out a form on the SLS Lead Platform with the following information:",
              "First Name",
              "Last Name",
              "Email",
              "Phone",
              "Active Loans",
              "Current System",
              "Heard From",
              "Status",
              "Request Type",
              "Message",
              "Attachments",
            ],
          },
        ],
      },
      {
        heading: "2. Review and Approval",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "A Sales Representative receives an email with the lead information. The representative reviews the form and approves it if the lead is eligible and considers servicing the lead's loans.",
            ],
            image: ["./assets/leads_1.png"],
          },
        ],
      },
      {
        heading: "3. Email Notification",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "After approval, an email is sent to the registered email address through the ticketing system, containing a link to: application.loanlinq.com. The email includes the Application Number.",
            ],
            image: ["./assets/email_noti.png"],
          },
        ],
      },
      {
        heading: "4. Application Number Entry",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "The customer clicks on the application.loanlinq.com link and enters the Application Number. An OTP is sent to the email provided by the lead for authentication.",
            ],
            image: [
              "./assets/application_no_1.png",
              "./assets/application_no_2.png",
              "./assets/application_no_3.png",
            ],
          },
        ],
      },
      {
        heading: "5. Lender Onboarding Form",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Upon successful OTP verification, the Lender Onboarding Form opens. The form includes fields for Name, TIN, ACH Details, etc. A TIN Check API is used, similar to the ACH form.",
            ],
            image: ["./assets/lender_onboarding.png"],
          },
        ],
      },
      {
        heading: "6. Master Service Agreement (MSA)",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "The user downloads the MSA (Master Service Agreement).",
              "The user signs the MSA offline.",
              "The signed MSA is attached by the user.",
            ],
            image: ["./assets/msa.png"],
          },
        ],
      },
      {
        heading: "7. Submission and Review",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "The user submits the form. The Boarding team receives an email. The Boarding team reviews and approves the onboarding.",
            ],
          },
        ],
      },
      {
        heading: "8. Record Creation",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "A record is created in TMO/Strategy. The user receives a welcome email with an invitation code to register on Loanlinq (LLQ) with the Default Role: Lender Admin. Registration link: LoanLinQ",
            ],
          },
        ],
      },
      {
        heading: "9. User Registration",
        subHeadings: [
          {
            subHeading: "",
            content: ["The user registers on LLQ."],
          },
        ],
      },
      {
        heading: "10. Onboarding Loans",
        subHeadings: [
          {
            subHeading: "",
            content: ["The user starts using LLQ and onboarding loans."],
          },
        ],
      },
    ],
  },
  {
    role: [],
    section: "Send Invitation Guide",
    headings: [
      {
        heading: "Introduction",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "This guide provides a step-by-step process for sending an invitation to vendors, investors, and borrowers through the ticketing system. The invitation includes access to our loan servicing portal, LoanLinq.",
            ],
          },
        ],
      },
      {
        heading: "Steps to Send an Invitation",
        subHeadings: [
          {
            subHeading: "1. Accessing the Invitation Feature",
            content: [
              "Login to the Ticketing System: Ensure you are logged into the ticketing system with the appropriate credentials.",
              "Click on 'Send Invitation': Navigate to the section where you can send invitations and click on the 'Send Invitation' button.",
            ],
            image: ["./assets/invitation.png"],
          },
          {
            subHeading: "2. Selecting the Recipient",
            content: [
              "Dropdown Selection: A dropdown menu will appear with options for 'Vendor', 'Investor', and 'Borrower'.",
              "Choose the Recipient Type: Select the appropriate recipient type from the dropdown menu.",
            ],
            image: ["./assets/recipient.png"],
          },
          {
            subHeading: "3. Choosing from Existing Lists",
            content: [
              "View Existing List: After selecting the recipient type, a list of existing lenders and borrowers will open.",
              "Select the Recipient: Choose the specific recipient to whom the invitation needs to be sent.",
            ],
            image: ["./assets/existing_list.png"],
          },
          {
            subHeading: "4. Configuring the Invitation Details",
            content: [
              "Select Email ID: Choose the recipient's email ID from the list.",
              "Assign Role: By default, the role is set to 'Lender Admin'. Ensure this is correct or select the appropriate role from the options available.",
            ],
            image: ["./assets/invitation_details.png"],
          },
          {
            subHeading: "5. Sending the Invitation",
            content: [
              "Send Email: Click on the send button to dispatch the invitation email.",
              "Invitation Email Contents: The email contains an invitation letter with an invitation code and a 'Register' button.",
            ],
            image: ["./assets/sending_invitation.png"],
          },
          {
            subHeading: "6. Registration Process for the Recipient",
            content: [
              "Invitation Email: The recipient will receive an email with an invitation to join our loan servicing portal.",
              "Click on Register: The email includes a 'Register' button that directs the user to the LoanLinq registration page: LoanLinq Registration.",
            ],
          },
          {
            subHeading: "7. Completing the Registration",
            content: [
              "Enter Details: The recipient will need to:",
              "Enter a password.",
              "Provide their registered phone number.",
              "Input the invitation code from the email.",
              "Access LoanLinq: After entering the details, the LoanLinq login page will open.",
            ],
            image: ["./assets/invitation_registration.png"],
          },
          {
            subHeading: "8. Authentication",
            content: [
              "Login: The user enters their email ID and password.",
              "OTP Verification: For authentication purposes, an OTP is sent to the registered email ID.",
              "Access Loan Portfolio: Once authenticated, the user can view their loan portfolio.",
            ],
          },
        ],
      },
    ],
  },
  {
    role: [],
    section: "New Lender Onboarding Guide",
    headings: [
      {
        heading: "Introduction",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "This guide provides a comprehensive overview of the New Lender Onboarding process within the Loanlinq ticketing system. It is designed to help the Customer Service Representatives (CSR) efficiently manage the onboarding of new lenders.",
            ],
          },
        ],
      },
      {
        heading: "Accessing the New Lender Onboarding Tab",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Log into the Ticketing System:",
              "Use your credentials to log into the Loanlinq ticketing system.",
              "Navigate to the New Lender Onboarding Tab:",
              "On the main dashboard, locate and click on the 'New Lender Onboarding' tab.",
            ],
          },
        ],
      },
      {
        heading: "Viewing New Lenders",
        subHeadings: [
          {
            subHeading: "List of New Lenders",
            content: [
              "After clicking on the New Lender Onboarding tab, a list of all newly onboarded lenders will be displayed.",
            ],
          },
        ],
      },
      {
        heading: "Reviewing Lender Information",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Select a Lender:",
              "Click on the 'Edit' button next to the lender's name to open their detailed information form.",
              "Lender Form Sections:",
              "General Information: Review the lender’s basic details like Name, Contact details, Address etc.",
              "Details Information: Check specific details provided by the lender related to Lender code, Loan type, categories etc.",
              "ACH Information: Verify the ACH (Automated Clearing House) details.",
            ],
          },
        ],
      },
      {
        heading: "Approving a Lender",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Review and Approve:",
              "If all the information is accurate and satisfactory, click the 'Approve' button.",
              "Email Notification:",
              "Upon approval, an automated email will be sent to the lender, informing them of their approval status.",
              "Update Lender List:",
              "The lender’s information will be updated in the lender list to reflect their approved status.",
            ],
          },
        ],
      },
      {
        heading: "Requesting More Information",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "More Info Tab:",
              "If additional information is required or if corrections are needed, click on the 'More Info' tab.",
              "Notes Window:",
              "A notes window will open where you can input all necessary corrections or additional information required.",
              "Create Request:",
              "After entering the required information, click the 'Create' button.",
              "Email Notification:",
              "An email will be sent to the lender, notifying them to log into Loanlinq and make the necessary changes.",
            ],
          },
        ],
      },
      {
        heading: "Updating Lender Information",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "Update Tab:",
              "If you need to update the lender’s information directly, use the 'Update' tab.",
              "Save Changes:",
              "Make the required updates to the lender’s form and save the changes.",
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["V"],
    section: "Broker's Help Guide",
    headings: [
      {
        heading: "Login & Password Recovery",
        id: "Broker's-Login",
        subHeadings: [
          {
            subHeading: "1.1 Login - Existing User",
            id: "Broker's-1.1",
            qa: [
              {
                question: "How do I log in as an existing user?",
                answer: [
                  "Click on the link provided by SLS to access the portal.",
                  "You will be redirected to the LoanLinQ portal login page.",
                  "Enter your registered username and password.",
                  "Click 'Continue' to generate an OTP sent to your registered email.",
                  "Enter the OTP and click 'Verify OTP and continue' to log in.",
                ],
                image: ["./assets/Login.png"],
              },
            ],
          },
          {
            subHeading: "1.2 Recover Password",
            id: "Lender's-1.2",
            qa: [
              {
                question: "What should I do if I forgot my password?",
                answer: [
                  "Click on 'Forgot Password?' on the login page.",
                  "A pop-up window will appear for resetting your password.",
                  "Enter your registered email address and click 'Next.'",
                  "You will receive an autogenerated key on your email.",
                  "Enter the key and click 'Next' to proceed with resetting your password.",
                ],
                image: ["./assets/recover_password.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Navigation",
        id: "Broker's-Navigation",
        subHeadings: [
          {
            subHeading: "2. Navigation",
            id: "Lender's-2.",
            qa: [
              {
                question: "What sections does the Navigation menu comprise?",
                answer: [
                  "This navigation menu comprises eight sections: Dashboard, Reports and Documents, Secure Document Upload, Forms, Help, Account, and a Guided tour. You can switch between these sections by simply clicking on them.",
                ],
                image: ["./assets/Navigation.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Dashboard",
        id: "Broker's-Dashboard",
        subHeadings: [
          {
            subHeading: "3. Dashboard",
            id: "Broker's-3.",
            qa: [
              {
                question: "What information does the Dashboard display?",
                answer: [
                  "Portfolio balance overview.",
                  "Upcoming payments summary.",
                  "Total number of loans and outstanding charges.",
                  "Loan aging and insurance expiry details.",
                  "Revenue breakdown and analysis.",
                  "Loan distribution by priority, maturity, and property type.",
                  "Portfolio-at-a-glance for quick insights.",
                  "Detailed views of past payments and loan portfolios.",
                ],
              },
            ],
          },
          {
            subHeading: "3.1 Dashboard -Broker Portfolio Balance",
            id: "Broker's-3.1",
            qa: [
              {
                question: "What is the Broker Portfolio Balance?",
                answer: [
                  `Broker Portfolio- The term ' Broker portfolio balance' typically refers to the total amount of funds
                  that a broker has invested or allocated across various loans or investments within their portfolio. In a
                  broker portal, it's a dashboard or summary section that displays this aggregated balance. This
                  balance can fluctuate based on factors such as repayments, interest accruals, and new investments
                  or loans made by the broker.`,
                ],
                image: ["./assets/lender_portfolio_balance.png"],
              },
            ],
          },
          {
            subHeading: "3.2 Dashboard - Upcoming Payments",
            qa: [
              {
                question: "What are upcoming payments?",
                answer: [
                  `Upcoming payments on a broker portal typically refer to a section or feature that displays the
                   scheduled payments that broker are set to receive from borrowers within a certain timeframe. This
                  feature is useful for broker to monitor their incoming cash flows and to anticipate when they can
                  expect to receive payments from borrowers. It helps brokers stay organized and manage their
                  finances effectively.`,
                ],
                image: ["./assets/upcoming_payments.png"],
              },
            ],
          },
          {
            subHeading:
              "3.3 Dashboard - Total Number of Loans and Outstanding Charges",
            qa: [
              {
                question:
                  "What information is displayed in the Total Number of Loans and Outstanding Charges?",
                answer: [
                  `In a broker portal, the 'total number of loans' metric is displayed prominently on a dashboard,
                  providing broker with a quick overview of the size and scope of their loan portfolio. Having access to
                  this information allows brokers to track portfolio growth over time and monitor changes in the loan
                  portfolio composition. The 'outstanding charges' section of the broker portal would display details
                  such as the type of charge, the amount owed, loan account, and the status of the charge.`,
                ],
                image: ["./assets/outstanding.png"],
              },
            ],
          },
          {
            subHeading: "3.4 Dashboard - Loan Aging and Insurance Expiry",
            qa: [
              {
                question: "What is Loan Aging and Insurance Expiry?",
                answer: [
                  "Loan aging provides lenders with insights into the payment behavior of borrowers and allows them to identify loans that may require closer attention or follow-up actions.",
                  `The 'Insurance expiry' section shows details of insurance policies linked to loans in the
                  broker's portfolio expiring within the next 30 days. This helps brokers track upcoming
                  expirations, allowing them to promptly renew coverage or address uninsured loan risks.`,
                ],
                image: ["./assets/loan_aging.png"],
              },
            ],
          },
          {
            subHeading: "3.5 Revenue Breakdown and Analysis",
            qa: [
              {
                question:
                  "What does the Revenue Breakdown and Analysis section show?",
                answer: [
                  "Revenue refers to the total income generated from lending activities within a specified period, with detailed breakdowns of revenue sources, such as interest income versus fee income.",
                ],
                image: ["./assets/revenue_breakdown.png"],
              },
            ],
          },
          {
            subHeading: "3.6 Loan Distribution by Lien Priority",
            qa: [
              {
                question: "What is Loan Distribution by Lien Priority?",
                answer: [
                  `This refers to a breakdown or visualization of the loans within a broker's portfolio based on their lien
                  priority, determining the order in which creditors are entitled to claim repayment in the event of
                  default or foreclosure.`,
                ],
                image: ["./assets/loan_distribution(3.6).png"],
              },
            ],
          },
          {
            subHeading: "3.7 Loan Aging",
            qa: [
              {
                question: "What is Loan Aging?",
                answer: [
                  `Loan Aging refers to the process of categorizing loans based on their age or the length of
                  time they have been outstanding. This categorization helps brokers assess the risk associated
                  with their loan portfolio and track the performance of loans over time.`,
                  `In a broker portal, the 'loan aging' feature would display loans grouped into different age
                  categories, such as current, 30 days past due, 60 days past due, etc. It provides brokers with
                  insights into the payment behavior of borrowers and allows them to identify loans that may
                  require closer attention or follow-up actions.`,
                ],
                image: ["./assets/image(3.7).png"],
              },
            ],
          },
          {
            subHeading: "3.8 Loan Distribution by Maturity",
            qa: [
              {
                question: "What is Loan Distribution by Maturity?",
                answer: [
                  `This refers to a breakdown or visualization of the loans within a broker's portfolio based on their
                  maturity dates.`,
                ],
                image: ["./assets/loan_distribution(3.8).png"],
              },
            ],
          },
          {
            subHeading: "3.9 Loan Distribution by Property Type",
            qa: [
              {
                question: "What is Loan Distribution by Property Type?",
                answer: [
                  `This feature categorizes loans based on the type of property serving as collateral, helping brokers
                  assess their exposure to different types of real estate assets.`,
                ],
                image: ["./assets/loan_distribution(3.9).png"],
              },
            ],
          },
          {
            subHeading: "3.10 Portfolio at a Glance",
            qa: [
              {
                question: "What is the Portfolio at a Glance section?",
                answer: [
                  `Provides a concise overview of the broker's entire portfolio of loans, displaying key information such
                  as the total number of loans, loan account numbers, next due dates, maturity dates, and the l
                  broker's principal investment in each loan.`,
                ],
                image: ["./assets/image(3.10).png"],
              },
            ],
          },
          {
            subHeading: "3.11 Upcoming Payments",
            qa: [
              {
                question: "What are upcoming payments?",
                answer: [
                  `Upcoming payments on a broker portal typically refer to a section or feature that displays
                  information about scheduled payments that borrowers are obligated to make in the near future. For
                  broker, the 'Upcoming payments' feature is useful for tracking expected cash inflows, managing cash
                  flow projections, and ensuring timely receipt of payments from borrowers. It allows brokers to stay
                  informed about upcoming payment obligations and take any necessary actions to follow up on
                  payments or address any issues that may arise.`,
                ],
                image: ["./assets/image(3.11).png"],
              },
            ],
          },
          {
            subHeading: "3.12 Loan Charges",
            qa: [
              {
                question: "What are Loan Charges?",
                answer: [
                  "Tracking pending loan charges for various borrower services is essential for effective financial management, risk mitigation, and customer communication.",
                ],
                image: ["./assets/image(3.12).png"],
              },
            ],
          },
          {
            subHeading: "3.13 Past Payments to Lender",
            qa: [
              {
                question: "What are Past Payments to Lender?",
                answer: [
                  "Displays a history of payments made by borrowers or servicing entities to the lender in previous periods, providing a detailed record of all payments received.",
                ],
                image: ["./assets/image(3.13).png"],
              },
            ],
          },
          {
            subHeading: "3.14 Past Loan Portfolio",
            qa: [
              {
                question: "What is the Past Loan Portfolio?",
                answer: [
                  `Provides a historical overview of loans that have been part of the broker's portfolio but are no longer
                  active or current.`,
                ],
                image: ["./assets/image(3.14).png"],
              },
            ],
          },
          {
            subHeading: "3.15 Attachment & Loan Boarding",
            qa: [
              {
                question: "What is Attachment & Loan Boarding?",
                answer: [
                  "Refers to a feature where brokers can download, manage, and view documents related to their loan portfolio.",
                ],
                image: ["./assets/image(3.15).png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Default Management",
        subHeadings: [
          {
            subHeading: "4. Default Management",
            qa: [
              {
                question: "What does Default Management include?",
                answer: [
                  "Overview of loans more than 30 days delinquent.",
                  "Loans currently under foreclosure.",
                  "Details of loans that have undergone workout plans post-default.",
                ],
                image: ["./assets/default_management.png"],
              },
            ],
          },
        ],
      },
      // {
      //   heading: "Secure Document Upload",
      //   subHeadings: [
      //     {
      //       subHeading: "5. Secure Document Upload",
      //       qa: [
      //         {
      //           question: "How do I upload documents securely?",
      //           answer: [
      //             "Use the Secure Document Upload section to upload necessary documents or request information from specific departments by providing relevant details such as loan account numbers and property addresses.",
      //           ],
      //           image: ["./assets/secure_document_upload.png"],
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   heading: "Forms",
      //   subHeadings: [
      //     {
      //       subHeading: "6. Forms",
      //       qa: [
      //         {
      //           question: "Where can I find and download forms?",
      //           answer: [
      //             "Visit the Forms section to download forms for loan servicing needs, including address changes, ACH enrollments, demand requests, and more.",
      //           ],
      //           image: ["./assets/forms.png"],
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        heading: "Help",
        subHeadings: [
          {
            subHeading: "5. Help",
            qa: [
              {
                question: "Where can I get help if I encounter issues?",
                answer: [
                  "The Help section provides contact information, FAQs, terms of service, and policy documents to assist with any queries or troubleshooting needs.",
                ],
                image: ["./assets/help.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Account",
        subHeadings: [
          {
            subHeading: "6. Account",
            qa: [
              {
                question: "How can I manage multiple accounts or roles?",
                answer: [
                  `Access different accounts or roles through the Account section to view portfolios from various
                  perspectives, including broker views and brokerage-originated loans.`,
                ],
                image: ["./assets/account.png"],
              },
            ],
          },
        ],
      },
      {
        heading: "Guided Tour",
        subHeadings: [
          {
            subHeading: "7. Guided Tour",
            qa: [
              {
                question: "What is the purpose of this guided tour?",
                answer: [
                  "The purpose of this guided tour is to provide a step-by-step walkthrough of the portal's features, functionalities, and navigation options. It aims to highlight key aspects of the portal to help users become comfortable and confident in utilizing the portal to accomplish their objectives efficiently.",
                ],
                image: ["./assets/guided_tour.png"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["L", "V"],
    section: "Adding Roles to Your Account",
    headings: [
      {
        heading: "",
        subHeadings: [
          {
            subHeading: "Disclaimer",
            content: [
              "Before Lender Admins can add accounts for lenders, they must first create a role with the specific permissions they wish to grant to the lender. Multiple roles can be created to provide different levels of access according to your requirements.",
            ],
          },
        ],
      },
      {
        heading: "",
        subHeadings: [
          {
            subHeading: "1. Accessing the Role Management Page",
            // content: [
            //   "Log in to your Loanlinq account and navigate to the dashboard.",
            //   "Go to the profile section at the top right corner, where your name is displayed.",
            //   "Click on the dropdown menu next to your name and select ‘Manage Role’.",
            // ],
            outerli: [
              "Log in to your Loanlinq account and navigate to the dashboard.",
              "Go to the profile section at the top right corner, where your name is displayed.",
              "Click on the dropdown menu next to your name and select ‘Manage Role’.",
            ],
            image: ["./assets/manage_role.png"],
          },
          {
            subHeading: "2. Viewing Existing Roles",
            outerli: [
              "Once you are on the Role Management page, you will see a list of all roles currently assigned to your account.",
            ],
          },
          {
            subHeading: "3. Creating a New Role",
            outerli: ["To create a new role for someone else:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Click on the ‘Add Role’ button located in the top right corner of the Role Management page.",
                  "This action will take you to the Create Role page.",
                ],
              },
            ],
            image: ["./assets/add_role.png"],
          },

          {
            subHeading: "4. Filling Out Role Details",
            // content: [
            //   "On the Create Role page, fill in the following fields:",
            //   "Role Name: Enter the name for the new role.",
            //   "Role Type: Choose the type of role from the dropdown (e.g., lender, broker).",
            //   "Role Description: Provide a brief description of the role’s purpose.",
            //   "Is Active: Select ‘Yes’ to activate the role.",
            // ],
            outerli: ["On the Create Role page, fill in the following fields:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Role Name: Enter the name for the new role.",
                  "Role Type: Choose the type of role from the dropdown (e.g., lender, broker).",
                  "Role Description: Provide a brief description of the role’s purpose.",
                  "Is Active: Select ‘Yes’ to activate the role.",
                ],
              },
            ],
            image: ["./assets/create_role.png"],
          },

          {
            subHeading: "5. Enabling Module Access and Reports",
            outerli: [
              "Scroll down to the Module Access and Reports sections.",
              "Enable the buttons for all modules and reports to which you want the new role to have access.",
            ],
            image: ["./assets/create_role_1.png"],
          },

          {
            subHeading: "6. Finalizing the Role Creation",
            outerli: [
              "After completing all fields and enabling the required access, click on the ‘Create Role’ button.",
              "A confirmation message will appear indicating that the role has been successfully created.",
            ],
            image: ["./assets/create_role_3.png"],
          },

          {
            subHeading: "7. Editing or Deleting a Role",
            // content: [
            //   "To edit or delete an existing role:",
            //   "Go to ‘Manage Roles’, and you will be directed to the Roles page.",
            //   "Select the role you would like to edit or delete from the list.",
            //   "Click on the ‘Edit’ button to make changes to the role.",
            //   "After making your edits, click the ‘Update Role’ button to save the changes.",
            //   "To delete a role, select No in is Active field  in Role Information section. This will disable the role.",
            // ],
            outerli: [
              "To edit or delete an existing role:",
              "To delete a role, select No in is Active field  in Role Information section. This will disable the role.",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "Go to ‘Manage Roles’, and you will be directed to the Roles page.",
                  "Select the role you would like to edit or delete from the list.",
                  "Click on the ‘Edit’ button to make changes to the role.",
                  "After making your edits, click the ‘Update Role’ button to save the changes.",
                ],
              },
            ],
            image: ["./assets/edit_role.png", "./assets/delete_role.png"],
          },

          {
            subHeading: "Conclusion",
            content: [
              "You have now successfully created and assigned a new role in your Loanlinq account.",
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["L"],
    section: "How Lender Admins Can Add Accounts for Lenders",
    headings: [
      {
        heading: "Step-by-Step Guide",
        subHeadings: [
          {
            subHeading: "1. Logging In and Navigating to the Admin Role",
            outerli: [
              "Log in to your Loanlinq account and navigate to the dashboard.",
              "Go to the profile section at the top right corner, where your name is displayed.",
              "Click on the dropdown menu next to your name and select ‘Admin Role’.",
            ],
            image: ["./assets/admin_menu.png"],
          },
          {
            subHeading: "2. Accessing the User Management Page",
            outerli: [
              "Once on the Admin page, locate the ‘Add User’ button on the top right side of the screen.",
              "Click on the ‘Add User’ button to open the User Information page.",
            ],
            image: ["./assets/add_user.png"],
          },
          {
            subHeading: "3. Filling Out User Information",
            // content: [
            //   "Complete the fields on the User Information page:",
            //   "First Name: Enter the first name of the new user.",
            //   "Last Name: Enter the last name of the new user.",
            //   "Phone Number: Provide the phone number for the user.",
            //   "Department Name: Specify the department the user will belong to.",
            //   "User Name (Email): Enter the email address that will be used as the username.",
            //   "Activated Field: Set this field to ‘Active’ to activate the user account.",
            // ],
            outerli: [
              "Complete the fields on the User Information page:",
              "Activated Field: Set this field to ‘Active’ to activate the user account.",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "First Name: Enter the first name of the new user.",
                  "Last Name: Enter the last name of the new user.",
                  "Phone Number: Provide the phone number for the user.",
                  "Department Name: Specify the department the user will belong to.",
                  "User Name (Email): Enter the email address that will be used as the username.",
                ],
              },
            ],
            image: ["./assets/create_user.png"],
          },

          {
            subHeading: "4. Assigning Accounts and Roles",
            outerli: [
              "Accounts: Select the accounts to be assigned to the user from the dropdown list.",
              "Assign Role: Choose the appropriate role from the dropdown menu under the ‘Assign Role’ field.",
            ],
            image: ["./assets/assign_role.png"],
          },

          {
            subHeading: "5. Setting Permissions",
            outerli: [
              "Note: When you select a role, the permissions granted to that role will automatically be enabled.",
              "You cannot edit the permissions in the Module Access or Reports sections directly. If you need to make changes to the permissions, you will need to modify the role itself.",
            ],
          },

          {
            subHeading: "6. Creating the User Account",
            outerli: [
              "Once all required fields are completed, click on the ‘Create User’ button.",
              "A confirmation message will appear, indicating that the new user account has been successfully created.",
            ],
            image: ["./assets/create_user_1.png"],
          },

          {
            subHeading: "7. Email Notification",
            outerli: [
              "An email will be sent to the new lender's email address, providing them with the Loanlinq link and any necessary login details to access their account.",
            ],
          },
        ],
      },
      {
        heading: "Conclusion",
        subHeadings: [
          {
            subHeading: "",
            content: [
              "You have now successfully created a new lender account in Loanlinq, with the appropriate access and permissions set by the role you assigned. The new lender will receive an email notification with a link to access their account. If permission changes are needed, update the role itself.",
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["B"],
    section: "How to Use Same Day Payment on LoanLinQ",
    headings: [
      {
        heading: `Step 1: Go to the "Same Day Payment" tab in the menu.`,
        subHeadings: [
          {
            subHeading: ``,
          },
        ],
      },
      {
        heading: "Step 2: Review Important Notices",
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "Check Request Cut-Off Time: 3:00 PM Pacific Time",
              "A $30 service fee applies for Same Day Payments.",
              "Payments must be submitted on a business day (excluding holidays).",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "Any requests submitted after 3:00 PM PT will be processed the next business day.",
                ],
              },
            ],
            image: ["./assets/new_same_day_payment.png"],
          },
        ],
      },

      {
        heading: "Step 3: Fill in Payment Details",
        subHeadings: [
          {
            subHeading: `1. Management and Loan Information`,
            outerli: ["This section is automatically filled:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Management Company Name",
                  "Loan Number",
                  "Pay To ",
                  "Property Address ",
                ],
              },
            ],
          },

          {
            subHeading: `2. Choose Loan Account`,
            outerli: [
              "Select your loan from the “Choose Loan Account” dropdown.",
            ],
          },
          {
            subHeading: `3. Choose Bank Account`,
            outerli: [
              "Select your bank account from the “Choose Bank Account” dropdown.",
            ],
          },
          {
            subHeading: `4. Verify Bank Information`,
            outerli: ["Confirm your:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Debit Account Number",
                  "Routing Number",
                  "Debit Account Name",
                ],
              },
            ],
          },

          {
            subHeading: `5. Enter Payment Amount`,
            outerli: [
              "Fill in the Check Amount field with the amount you wish to pay.",
            ],
          },
          {
            subHeading: `6. Add Optional Information: All are Compulsory fields`,
            outerli: ["Enter your:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Street Address",
                  "City, State, Zip",
                  "Comments/Instructions (if any)",
                ],
              },
            ],
          },
        ],
      },
      {
        heading: "Step 4: Choose Payment Type",
        subHeadings: [
          {
            subHeading: ``,
            outerli: ["Select the appropriate type for your payment:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Regular Payment",
                  "Principal Paydown",
                  "Other Fees & Charges",
                ],
              },
            ],
          },
        ],
      },

      {
        heading: "Step 5: Preview and Submit",
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "Click “Preview” to review your payment.",
              "On the next screen, sign and click “Submit” to complete the transaction.",
              "Draw your signature in the designated area.",
              "You will receive a confirmation email once the submission is complete. ",
            ],
            image: ["./assets/cheque_new.png", "./assets/cheque_new1.png"],
          },
        ],
      },
    ],
  },
  {
    role: ["B"],
    section: "How to Use One Time Payment on LoanLinQ",
    headings: [
      {
        heading: `Step 1:`,
        subHeadings: [
          {
            subHeading: `Go to the "One Time Payment" tab on the left-hand menu.`,
          },
        ],
      },
      {
        heading: `Step 2:`,
        subHeadings: [
          {
            subHeading: `Carefully review the message at the top. Ensure your account and routing information is correct before proceeding. Submission is not complete until you sign and press "Submit".`,
            image: ["./assets/one_time_payment_new.png"],
          },
        ],
      },

      {
        heading: `Step 3: Fill in Payment Details `,
        subHeadings: [
          {
            subHeading: `1. Management and Loan Information `,
            outerli: ["This section is automatically filled:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Management Company Name",
                  "Loan Number",
                  "Pay To",
                  "Property Address",
                ],
              },
            ],
            showLiAsP: true,
          },
          {
            subHeading: `2. Choose Loan Account`,
            outerli: [
              "Select your loan from the “Choose Loan Account” dropdown.",
            ],
          },
          {
            subHeading: `3. Choose Bank Account`,
            outerli: [
              "Select your bank account from the “Choose Bank Account” dropdown.",
            ],
          },
          {
            subHeading: `4. Verify Bank Information `,
            outerli: ["Confirm your:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Debit Account Number",
                  "Routing Number",
                  "Debit Account Name",
                ],
              },
            ],
          },
          {
            subHeading: `5. Enter Payment Amount`,
            outerli: [
              "Fill in the Check Amount field with the amount you wish to pay.",
            ],
          },
          {
            subHeading: `6. Add Optional Information: All are Compulsory fields`,
            outerli: ["Enter your:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Street Address",
                  "City, State, Zip",
                  "Comments/Instructions (if any)",
                ],
              },
            ],
          },
        ],
      },
      {
        heading: `Step 4: Choose Payment Type`,
        subHeadings: [
          {
            subHeading: `Select the appropriate type for your payment:`,
            outerli: [
              "Regular Payment",
              "Principal Paydown",
              "Other Fees & Charges",
            ],
          },
        ],
      },
      {
        heading: `Step 5: Choose your desired Payment Date using the calendar picker.`,
        subHeadings: [
          {
            subHeading: ``,
            image: ["./assets/one_time_payment_new1.png"],
          },
        ],
      },

      {
        heading: `Step 6:`,
        subHeadings: [
          {
            subHeading: ``,
            content: [
              `Click "Preview" to review your details before submission. Draw your signature in the designated area.`,
              "A confirmation email will be sent once the process is successfully completed.",
            ],

            image: [
              { 0: "./assets/one_time_payment_new2.png" },
              { 1: "./assets/one_time_payment_new3.png" },
            ],
            multipleCase: true,
          },
        ],
      },
    ],
  },
  {
    role: ["B"],
    section:
      "How to Set Up Monthly Recurring Payment Schedule (Autopay) on LoanLinQ",
    headings: [
      {
        heading: `Step 1: Navigate to Setup Autopay`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "In the Payments tab click on Recurring ACH.",
              "You will be taken to the Monthly Recurring Payment Schedule page.",
            ],
            image: ["./assets/recurring_ach_new.png"],
          },
        ],
      },

      {
        heading: `Step 2: Select the Loan Tab`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "You will see two tabs:",
              "Select the Non Scheduled Loans tab to set up autopay for inactive loans.",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "Scheduled Loans – shows loans already enrolled in autopay.",
                  "Non Scheduled Loans – shows loans not yet enrolled.",
                ],
              },
            ],
            image: ["./assets/recurring_ach_new1.jpeg"],
          },
        ],
      },

      {
        heading: `Step 3: Choose Loans for Autopay`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "Review the list of  loans in Non Scheduled Loans Tab.",
              "Use the checkboxes to select the loans you want to include in the autopay setup.",
              "Each row displays details such as Loan Account, Property Address, Amount, Day, and Date.",
              "Note: If you set up more than one loan, please be aware that they will be scheduled for the same day and linked to the same bank account.",
            ],
          },
        ],
      },

      {
        heading: `Step 4: Enter Autopay Details`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: ["Under the Permanency section:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Select Payment Day Loan – choose which Day of the month for autopay.",
                  "Schedule Date – It will automatically populate the date.",
                  "Account Type – choose Checking or Savings.",
                  "Bank Account – select an existing bank account or click “Add New Bank Account”.",
                ],
              },
            ],
            showLiAsP: true,
          },
        ],
      },

      {
        heading: `Step 5: Review the Summary`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: ["The Summary box will show:"],
            innerli: [
              {
                index: 0,
                content: [
                  "Total Scheduled Payment",
                  "Scheduled On date",
                  "Selected Bank Account",
                  "Number of Loans selected",
                  "Payment Type",
                  "Frequency (Monthly)",
                ],
              },
            ],
            showLiAsP: true,
          },
        ],
      },

      {
        heading: `Step 6: Read and Authorize`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "Read the Authorization statement carefully.",
              "Check “Yes” to confirm your agreement and authorize recurring payments.",
            ],
          },
        ],
      },

      {
        heading: `Step 7: Submit`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              `Click the "Submit" button to finalize the setup.`,
              "A confirmation email will be sent once your monthly recurring payment schedule has been successfully submitted.",
              "Disclaimer: If you miss a payment or are late, please ensure to make a One-Time Payment or Same-day Payment to avoid any issues. ",
              "If the scheduled date falls on a weekend or public holiday, the debit will occur on the next business day.",
              "Payments are considered received on the date of posting, not the date scheduled.",
              "Payments scheduled on the last day of a grace period may post the following business day and may incur a late charge.",
            ],
            middleNote: [
              {
                index: 2,
                text: "Additional Notes:",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    role: ["B"],
    section:
      "How to Add a New Loan Account",
    headings: [
      {
        heading: `Step 1 – Open the Account Section`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "After logging in to LoanLinq, the Dashboard is displayed by default.",
              "From the navigation menu, select Account.",
            ],
            image: ["./assets/Account_nav.png"],
          },
        ],
      },
      {
        heading: `Step 2 – Select Add Account`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "On the Account screen, locate the Add Account section.",
              "Click Add account to begin adding a new loan account.",
            ],
            image: ["./assets/account_nav1.png"],
          },
        ],
      },
      {
        heading: `Step 3 – Enter Loan Account Information`,
        subHeadings: [
          {
            subHeading: `On the Add Account screen, enter the required information:`,
            outerli: [
              "Account – Enter the new loan account number.",
              "Last 4 digits for your TIN / SSN – Enter the last four digits of the TIN or SSN associated with the loan.",
              "After entering the required information, click Add Account."
            ],
            image: ["./assets/add_account_nav.png"],
          },
        ],
      },
      {
        heading: `Step 4 – Confirm the New Loan Account`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "Once the new loan account is added, it will be available under the Change Account dropdown.",
              "Select the newly added loan account from the dropdown to switch to that account."
            ],
            image: ["./assets/add_account_nav4.png"],
            showLiAsP: true,
          },
        ],
      },
       {
        heading: `Step 5 – Access the New Loan Account`,
        subHeadings: [
          {
            subHeading: ``,
            outerli: [
              "After selecting the new loan account, the Dashboard will display information associated with that loan, including the Accounts Summary, Payment Summary, Payments, and Quick Access options.",
              "The borrower can now access and manage the newly added loan account through LoanLinq."
            ],
            showLiAsP: true,
          },
        ],
      },
    ],
  },
  {
    role: ["L"],
    section: "How to Access and Approve/Decline a Payoff Demand",
    headings: [
      {
        heading: ``,
        subHeadings: [
          {
            subHeading: ``,
            content: [
              `A payoff demand is a formal statement prepared by the loan servicer that outlines the total amount required to satisfy a loan in full as of a specific date. The quote includes the outstanding principal balance, accrued interest through the good-through date, and any additional fees or costs incurred. The Payoff Demands Management System helps streamline this process by giving lenders a streamlined way to review, approve, or decline a payoff request.`,
            ],
          },
        ],
      },
      {
        heading: `How to Access and Approve/Decline a Payoff Demand`,
        subHeadings: [
          {
            subHeading: ``,
            content: [
              `This guide outlines the steps for lenders to review, approve, or decline a payoff demand.`,
            ],
          },
          {
            subHeading: `Step 1 : Email Notification`,
            content: [
              `You will receive an email from Superior Loan Servicing (SLS) with the subject: "Payoff submitted with status 'Pending Lender Approval'"`,
            ],
            outerli: [
              "The email will contain:",
              "Click this button to proceed with reviewing the payoff demand.",
            ],
            innerli: [
              {
                index: 0,
                content: [
                  "The loan number",
                  "The payoff status (e.g., Pending Lender Approval)",
                  `A blue button: 
                  “Click here to View/Approve/Decline the payoff” 
                  `,
                ],
              },
            ],
            image: ["./assets/payoff_email.jpeg"],
          },
          {
            subHeading: `Step 2: How to login`,
            content: [``],
          },
          {
            subHeading: `A. If You Have a LoanIinQ Account:`,
            outerli: [
              `Click on the blue button in the email.`,
              `You will be redirected to the LoanIinQ portal.`,
              `Log in using your existing LoanIinQ credentials.`,
              `After logging in, Click on Payoff Demands Tab in the Navigation menu:`,
            ],
            innerli: [
              {},
              {},
              {},
              {
                index: 3,
                content: [
                  "Preview the payoff",
                  "Review fees, charges and the payoff amount.",
                  "Approve or Decline the payoff using the on-screen buttons",
                ],
              },
            ],
            image: ["./assets/payoff_login.jpeg", "./assets/payoff_table.png"],
          },
          {
            subHeading: `B. If You Do Not Have a LoanlinQ Account:`,
            content: [
              "Click the blue button in the email.",
              `You will be taken to a secure payoff tool page.`,
              `Enter your registered email address when prompted.`,
              `You will receive a One-Time Passcode (OTP) via email.`,
              `Enter the OTP to access the payoff review screen.`,
              `Your Pending payoff demands will be displayed here.`,
              `Click the "Click Here" button to view the pending payoff demand.`,
            ],
            image: [
              "./assets/payoff_ticketing.jpeg",
              "./assets/payoff_ticketing_table.jpeg",
            ],
          },
          {
            subHeading: `Step 3 : Approving or Declining a Payoff`,
            mainContent: [
              "Once inside the payoff demand:",
              "Click on “Preview Payoff Letter ” Button",
              "After Reviewing the Payoff Letter, you will then have two options:",
            ],
            secondLayer: [
              {
                index: 0,
                content: [
                  "You will see a preview button to review all payoff details.",
                  "You must carefully check:",
                ],
                innerli: [
                  {
                    index: 1,
                    content: [
                      "Fees",
                      "Recipient information",
                      "Supporting attachments",
                      "Communications",
                    ],
                  },
                ],
              },
              {
                index: 2,
                content: [
                  `✅ Approve  – If you agree with the terms. 
                  If you hold 100% ownership, your approval sends the payoff to the recipient automatically. Otherwise, it will wait for other lender actions or SLS review. 
                  `,
                  `❌ Decline – If you reject the payoff. 
                  You must provide a reason (e.g., "Incorrect fees") in the comment/remark section before submission. 
                  `,
                ],
              },
            ],
            threeLayers: true,
            layerType: "not-ordered",
            mainContentImage: [
              { index: 0, image: ["./assets/payoff_details.jpeg"] },
              { index: 1, image: ["./assets/payoff_letter.jpeg"] },
            ],
            extraNote: [
              {
                index: 2,
                title: "NOTE: THE IMPORTANCE OF TIMELY PAYOFF APPROVALS",
                content: [
                  `Timing is critical when it comes to approving payoff demands. Delays in approval can directly impact closing timelines, borrower satisfaction, and the overall servicing experience. Our system is designed to eliminate bottlenecks and help ensure that payoffs are reviewed and approved promptly.`,
                  `We strongly encourage lenders to review payoff requests as soon as possible after receiving notification. Doing so allows us to process payoffs efficiently, avoid unnecessary follow-ups, and maintain a high standard of service for all parties involved.`,
                  `By using the new system and prioritizing timely approvals, you help ensure a smooth payoff process, reduce risk, and uphold the professionalism your borrowers expect.`,
                ],
                className: "border p-4",
              },
            ],
          },
        ],
      },
    ],
  },
];

export const newDocumentationContent = documentationContent.map(
  (section, idx) => ({
    ...section,
    index: idx,
    headings: section?.headings?.map((heading) => {
      const headingId = slugify(`${section.section}-${heading.heading}`);
      return {
        ...heading,
        id: headingId,
        // id: `${section.section.split(" ")[0]}-${heading.heading.split(" ")[0]}`,
        subHeadings: heading?.subHeadings?.map((subHeading) => ({
          ...subHeading,
          // id: `${section.section.split(" ")[0]}-${
          //   subHeading.subHeading.split(" ")[0]
          // }`,
          id: slugify(`${section.section}-${subHeading.subHeading}`),
        })),
      };
    }),
  })
);
